import ActionTypes from '../constants/ActionTypes';
import Events from '../constants/Events';

export default function reducer(
  state = {
    permissions: null,
    isFetching: false,
    fetched: false,
    error: null,
    roles: [],
    userRole: {}
  },
  action
) {
  switch (action.type) {
    case ActionTypes.GET_PERMISSIONS: {
      return { ...state, isFetching: true, permissions: null };
    }
    case Events.RETRIEVED_PERMISSIONS: {
      return {
        ...state,
        isFetching: false,
        fetched: true,
        error: null,
        permissions: action.payload
      };
    }
    case Events.PERMISSIONS_FAILED: {
      return {
        ...state,
        isFetching: false,
        fetched: false,
        error: action.payload,
        permissions: []
      };
    }


    default:
      break;
  }

  return state;
}
